<template>
  <el-container class="CommunityManagement">
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="deptId"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-card>
    <div class="box">
      <el-card class="box-card">
        <div class="card-header">
          <span class="title">
            <span class="interval__mkhme"></span>
            {{ treeName }}
          </span>
          <div>
            查询时间<el-date-picker
              style="margin-left:10px"
              v-model="datePicker"
              :clearable="false"
              type="month"
              placeholder=""
            >
            </el-date-picker>
          </div>
        </div>
      </el-card>
      <el-card class="tabs-card">
        <div class="tabs-header">
          <span class="title_">总览</span>
          <span class="title_">新增</span>
          <span class="title_g">0个</span>
          <span class="title_">删除</span>
          <span class="title_g">0个</span>
          <span class="title_">修改</span>
          <span class="title_g">0个</span>
        </div>
        <div class="tabs-center">
          <div class="tabs-header-left">
            <span class="interval__mkhme" style="margin-right:10px;"></span
            >积分采集排行榜(共0人)
          </div>
          <div class="tabs-header-right">积分明细</div>
        </div>
        <div class="table-box"></div>
      </el-card>
    </div>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
// import { ElMessageBox, ElMessage } from "element-plus";
import { queryOrganList } from "@/api/system";
import util from "@util/js";
// import { deleteUser, resetPassword, stopUser } from "@/api/user";
export default defineComponent({
  name: "CommunityManagement",
  components: {},
  props: {},
  setup(props) {
    const state = reactive({
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
      },
      dataSource: [],
      tableParams: {
        userName: "",
        longitude: "",
        latitude: "",
        person: "",
        Property: "",
        Propertyphone: ""
      },
      datePicker: new Date(),
      treeName: "公安局" // 头的标题
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    const tableRef = ref(null);
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.deptId = item.deptId;
      state.userFormData.parentId = item.deptId;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await queryOrganList();
      const options = { pid: "parentId", id: "deptId", rootPid: result.top };
      const treeData = util.arrayToTree(result.deptList, options);
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.deptId;
          treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
      }
    };
    queryOrganTreAsync();

    return {
      ...refData,
      filterNode,
      currentChange
    };
  }
});
</script>
<style lang="scss" scoped>
.CommunityManagement {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }

  .box {
    flex: 2;
    display: flex;
    flex-direction: column;
    .tabs-card {
      // flex: 1;
      height: 90%;
      margin-left: 10px;
      margin-top: 10px;
      .tabs-header {
        background: #f6f9ff;
        padding: 10px 20px;
        font-size: 16px;
        .title_ {
          margin: 0 5px;
          color: #333;
          font-size: 16px;
        }
        .title_g {
          margin: 0 5px;
          color: #64b782;
          font-size: 16px;
        }
      }
      .tabs-center {
        display: flex;
        margin-top: 10px;
        .tabs-header-left {
          background: #f7f7f7;
          padding: 10px 20px;
          width: 30%;
          font-size: 14px;
        }
        .tabs-header-right {
          background: #f7f7f7;
          padding: 10px 20px;
          width: 72%;
          margin-left: 10px;
          font-size: 14px;
        }
      }
      .table-box {
        height: 85%;
        margin-top: 10px;
      }
    }
    .box-card {
      // flex: 1;
      margin-left: 10px;
      .card-header {
        display: flex;
        justify-content: space-between;
        .title {
          padding-left: 10px;
          color: #5584ff;
          font-size: 24px;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
